export default "__VITE_ASSET__APV1iiGe__"